module.exports = __webpack_public_path__ + "static/media/ilocalbox-logo.efd0e2c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/ilocalbox-logo.svg
// module id = 1320
// module chunks = 0